import { Component } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { readComment } from '../../../../shared/interfaces/story';
import { FirestoreService } from '../../../../shared/services/firestore.service';
import { ConsoleLoggerService } from '../../../../core/services/console-logger.service';
import { catchError, map } from 'rxjs/operators';
import { nav_path } from 'src/app/app-routing.module';

@Component({
  selector: 'anon-admin-comments',
  templateUrl: './admin-comments.component.html',
  styleUrls: ['./admin-comments.component.scss']
})
export class AdminCommentsComponent {
  comments$: Observable<readComment[]>;
  error: any;
  loading = true;
  public nav_path = nav_path;

  constructor(
    public db: FirestoreService,
    private logs: ConsoleLoggerService
  ) {
    this.comments$ = this.db.colGroupQuery$(`comments`, {})
      .pipe(
        map((comments: any) =>
          comments.sort((a: readComment, b: readComment) => b.created.seconds- a.created.seconds) as readComment[]
        ),
        catchError(error => {
          this.logs.error(`error getting admin comments`, error);
          this.error = error;
          return throwError(error);
        })
      );
  }
}
